export default "__VITE_ASSET__CgOsTm0d__"